export const changeUrlWithoutReload = (url: string) => window.history.replaceState({}, '', url);
